






import Vue from "vue"
import HorizontalCardList from "~/components/guideline/horizontalCardList/HorizontalCardList.vue"

export default Vue.extend({
  components: {
    HorizontalCardList,
  },
})
